<template>
    <div class="offer-icons-info" :class="{head: head}" v-if="offer?.id">
        <div v-if="offer?.is_steam_gift" class="offer-icons-info__item">
            <img class="offer-icons-info__item-img radius-0" src="/img/pages/product/icons/steam-gift.svg" alt="gift">
            <span class="offer-icons-info__item-info">
                {{ $t("Steam gift - is a gift card that you will receive on your Steam via email.", { ns: 'product' }) }}
                {{ $t("You can activate the game to add to your library or give it to someone else.", { ns: 'product' }) }}
            </span>
        </div>
        <div v-else-if="offer.offer_type_id === 9" class="offer-icons-info__item">
            <img class="offer-icons-info__item-img radius-0" src="/img/icons/platforms/pc.svg" alt="pc">

            <span class="offer-icons-info__item-info">
                {{ $t("You will instantly receive an account with the new game. Do not forget that you are covered by our Lifetime Guarantee and that our services are 100% Secure and Legal.", { ns: 'product'}) }}
            </span>
        </div>
        <div v-else-if="offer.offer_type_id === 4" class="offer-icons-info__item">
            <img class="offer-icons-info__item-img radius-0" src="/img/icons/account/account.svg" alt="account">

            <span class="offer-icons-info__item-info">
                {{ $t("You will instantly receive a console account with the new game. Do not forget that you are covered by our Lifetime Guarantee and that our services are 100% Secure and Legal.", { ns: 'product'}) }}
            </span>
        </div>
        <div v-else-if="offer.offer_type_id === 1 || offer.offer_type_id === 3 || offer.offer_type_id === 8" class="offer-icons-info__item">
            <img class="offer-icons-info__item-img radius-0" src="/img/pages/product/icons/key.svg" alt="key">

            <span class="offer-icons-info__item-info">
                {{ $t("The seller will send you a key that you can activate", { ns: 'product' }) }}
            </span>
        </div>
        <div class="offer-icons-info__item" v-if="offer?.game_marketplace && offer?.game_marketplace?.image_rounded">
            <img class="offer-icons-info__item-img" :src="offer.game_marketplace.image_rounded.orig.src" alt="key">
            <span class="offer-icons-info__item-info" v-if="offer.game_marketplace?.description && offer.game_marketplace?.description.trim().length">
                {{ offer.game_marketplace.description }}
                <!-- {{ $t('The product can only be activated for the {platform} platform.',{ platform: offer.game_marketplace.name, ns: 'product' }) }} -->
            </span>
        </div>

        <div class="offer-icons-info__item" v-if="offer?.game_edition && !showRegion && showEdition">
            <img class="offer-icons-info__item-img" src="/img/pages/product/icons/edition-white.svg" alt="edition">
            <span class="offer-icons-info__item-info"  v-html="$t('This is the {edition} of the product.',{ 
                edition: '<b>' + offer.game_edition.name + '</b>',
                ns: 'product', 
            })"></span>
        </div>

        <div class="offer-icons-info__item region" v-if="offer?.region_game_card">
            <img class="offer-icons-info__item-img" :src="offer?.region_game_card.id === 1 ? '/img/default/global.svg' : offer.region_game_card.image_rounded.orig.src" :alt="offer.region_game_card.image_rounded.orig.alt">
            <span class="offer-icons-info__item-info">
                {{ getStatusText() }}
            </span>
        </div>
        <RegionOffer v-if="showRegion" :offer="offer" :typeIcon="2"/>
    </div>
    <div class="offer-icons-info placeholder-wrap" :class="{head: head}" v-else>
        <span class="placeholder icon"></span>
        <span class="placeholder icon"></span>
        <span class="placeholder icon"></span>
        <span class="placeholder icon" v-if="!showRegion && showEdition"></span>
    </div>
</template>

<script>
import RegionOffer from './RegionOffer.vue';
export default {
    components: {
        RegionOffer,
    },
    props: {
      offer: {
        type: Object,
        required: true
      },
      showRegion: {
        type: Boolean,
        default: false
      },
      head: {
        type: Boolean,
        default: false
      },
      showEdition: {
        type: Boolean,
        default: true
      }
    },
    data() {
        return {
            userCountry: window.common.country || null,
        };
    },
    methods: {
        getStatusText() {
            const region = this.offer?.region_game_card || null;
            const currentCode = this.userCountry.code;

            if (!region || !currentCode) return;

            const hasCountry = region.countries.some(
                country => country.code === currentCode
            );

            if (region.id === 1) {
                return this.$t('Can be activated from any country');
            } else if (hasCountry) {
                return this.$t('Can be activated from {country}.', {ns: 'product', country: this.offer?.region_game_card.name});
            } else {
                return this.$t('Can be activated from some countries');
            }
        },
    }
};
</script>

<style lang="scss" scoped>
    .offer-icons-info{
        display: flex;
        align-items: center;
        gap: 10px;
        &.placeholder-wrap{
            pointer-events: none;
            .icon{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                @media only screen and (max-width: 991px) {
                    &:last-child{
                        display: none;
                    }
                }
            }
        }
        &__item{
            position: relative;
            background-color: #4E8AFF;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            max-width: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            @media only screen and (max-width: 991px) {
                width: 20px;
                height: 20px;
            }
            &-img{
                width: 18px;
                height: 18px;
                border-radius: 50%;
                max-width: 18px;
                &.radius-0{
                    border-radius: 0;
                }
                @media only screen and (max-width: 991px) {
                    width: 13px;
                    height: 13px;
                    max-width: 13px;
                }
            }
            &-info{
                position: absolute;
                pointer-events: none;
                opacity: 0;
                transition: 0.4s;
                right: 0;
                bottom: 40px;
                border-radius: 12px;
                padding: 12px 15px;
                box-shadow: 0px 0px 15px 0px #00000026;
                z-index: 100;
                max-width: 260px;
                width: max-content;
                background-color: #fff;
                font-family: "Avenir-Next";
                font-weight: 400;
                font-size: 14px;
                line-height: 140%;
                letter-spacing: 0px;
                color: #505050;
                @media only screen and (max-width: 767px) {
                    left: -10px;
                    right: auto;
                }
                :deep(b){
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                }
            }
            &.region{
                //background-color: transparent;
                .offer-icons-info__item-img{
                    width: 30px;
                    height: 30px;
                    max-width: 30px;
                    @media only screen and (max-width: 991px) {
                        width: 20px;
                        height: 20px;
                        max-width: 20px;
                    }
                }
                @media only screen and (max-width: 767px) {
                    display: flex;
                    width: 20px;
                    height: 20px;
                    max-width: 20px;
                    .offer-icons-info__item-img{
                        width: 20px;
                        height: 20px;
                        max-width: 20px;
                    }
                }
            }
            &:hover{
                .offer-icons-info__item-info{
                    pointer-events: all;
                    opacity: 1;
                }
            }
        }
        &.head{
            @media only screen and (min-width: 1440px) and (max-width: 1639px) {
                &.placeholder-wrap .icon{
                    width: 24px;
                    height: 24px;
                }
                .offer-icons-info__item{
                    width: 24px;
                    height: 24px;
                    max-width: 24px;
                    &-img{
                        width: 16px;
                        height: 16px;
                        max-width: 16px;
                    }
                }
                .region .offer-icons-info__item-img{
                    width: 22px;
                    height: 22px;
                    max-width: 22px;
                }
            }
            @media only screen and (max-width: 991px) {
                
                &.placeholder-wrap {
                    display: none;
                }
                .offer-icons-info__item{
                    width: 20px;
                    height: 20px;
                    max-width: 20px;
                    display: flex;
                    &-img{
                        width: 14px;
                        height: 14px;
                        max-width: 14px;
                    }
                }
                .region .offer-icons-info__item-img{
                    width: 18px;
                    height: 18px;
                    max-width: 18px;
                }
            }
        }
    }
</style>